(function () {
  var up = document.getElementById('byld-upsell-tpl');
  var note = document.getElementById('byld-note-tpl');
  if (!up && !note) return;
  var drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return;
  var max = up ? (Number(up.getAttribute('data-max')) || 3) : 0;
  var inCart = [];
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setupSlider(box) {
    var cards = [].slice.call(box.querySelectorAll('.byld-up__item'));
    var fresh = cards.filter(function (el) { return inCart.indexOf(String(el.getAttribute('data-pid'))) === -1; });
    var pool = fresh.length ? fresh : cards;
    var shown = 0;
    cards.forEach(function (el) {
      var hide = pool.indexOf(el) === -1 || shown >= max;
      el.hidden = hide;
      if (!hide) shown++;
    });
    box.hidden = shown === 0;
    box.classList.toggle('is-single', shown <= 1);
    var track = box.querySelector('.byld-up__track');
    if (track) track.scrollLeft = 0;
  }

  function refreshAll() {
    [].slice.call(drawer.querySelectorAll('[data-byld-upsell]')).forEach(setupSlider);
  }

  function loadCart() {
    if (!up || !window.fetch) return;
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inCart = (c.items || []).map(function (i) { return String(i.product_id); });
        refreshAll();
      })
      .catch(function () {});
  }

  function place() {
    var content = drawer.querySelector('.cart-drawer__content');
    if (!content) return;
    var items = content.querySelector('.cart-drawer__items');
    var summary = content.querySelector('.cart-drawer__summary');
    if (note && !content.querySelector('[data-byld-note]')) {
      var n = note.content.firstElementChild.cloneNode(true);
      if (items) content.insertBefore(n, items); else content.insertBefore(n, content.firstChild);
    }
    if (up && !content.querySelector('[data-byld-upsell]')) {
      var box = up.content.firstElementChild.cloneNode(true);
      if (items) items.appendChild(box);
      else if (summary) content.insertBefore(box, summary);
      else return;
      setupSlider(box);
    }
  }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-byld-up-nav]');
    if (!nav) return;
    e.preventDefault();
    var box = nav.closest('[data-byld-upsell]');
    var track = box && box.querySelector('.byld-up__track');
    if (!track) return;
    var dir = Number(nav.getAttribute('data-byld-up-nav')) || 1;
    var w = track.clientWidth;
    var atEnd = track.scrollLeft + w >= track.scrollWidth - 4;
    var atStart = track.scrollLeft <= 4;
    if (dir > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
    else if (dir < 0 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    else track.scrollBy({ left: dir * w, behavior: 'smooth' });
  });

  var timer = null;
  function queueCart() { clearTimeout(timer); timer = setTimeout(loadCart, 250); }
  var obs = new MutationObserver(function () { obs.disconnect(); place(); start(); queueCart(); });
  function start() { obs.observe(drawer, { childList: true, subtree: true }); }
  document.addEventListener('cart:update', function () { obs.disconnect(); place(); start(); queueCart(); });
  place(); start(); loadCart();
})();